module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("This edition published in 2013 by Grub Street"), _c('br'), _vm._v("4 Rainham Close"), _c('br'), _vm._v("London"), _c('br'), _vm._v("SW11 6SS"), _c('br')]), _c('a', {
    attrs: {
      "href": "http://www.grubstreet.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.grubstreet.co.uk")]), _c('br'), _vm._v("Twitter @grub_street"), _c('br'), _vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:food@grubstreet.co.uk"
    }
  }, [_vm._v("food@grubstreet.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Text copyright © Richard Olney 1994, 2013"), _c('br'), _vm._v("Foreword copyright © Alice Waters 1994"), _c('br'), _vm._v("Photograph on "), _c('a', {
    attrs: {
      "href": "#/Contents#page_4"
    }
  }, [_vm._v("page 4")]), _vm._v(" © Gail Skoff 1994"), _c('br'), _vm._v("Copyright this edition © Grub Street 2013"), _c('br'), _vm._v("Design Sarah Driver")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("The moral right of the author has been asserted")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("A CIP record for this title is available from The British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording or any information storage and retrieval system, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Printed and bound by Berforts Group, UK")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_c('b', [_vm._v("Publisher’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("This book was first published in 1994 in the United States and so readers should be aware that the Acknowledgements refer to the original edition and not this present edition. Elsewhere apart from adding metric measurements the original text is largely unchanged and so there may be references to people, places and practices no longer in existence.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2710f8b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 60
// module chunks = 0